module.exports = __webpack_public_path__ + "img/cmb.327c3835.png";